<template>
    <div class="loader-wrapper">
        <span class="loader-circle"></span>
    </div>
</template>

<script setup lang="ts">
</script>
